import React, { useState } from "react";
import "./Product_Info_Card.css";
import Green_Outline_Btn from "../common_btn/green_outline_btn/Green_Outline_Btn";
import Best_seller_heart from "../product_card/Best_seller_heart/Best_seller_heart";
import { Link, useNavigate } from "react-router-dom";
import { encodeId, RolesIds, variant_type } from "../../../utils/common";
import { useDispatch, useSelector } from "react-redux";
import { getAllCart, postCart } from "../../../features/cart/cartSlice";
import StarRatings from "react-star-ratings";
const Product_Info_Card = ({
  id,
  imgSrc,
  vdoSrc,
  productName,
  priceText,
  mrp,
  kgText,
  rating,
  product,
  productCategory,
  activeVariant,
  showdiscount = false,
  discount_message = false,
}) => {
  const currentCurrency = useSelector((state) => state.master.currentCurrency);
  const rate = Number(currentCurrency?.rate) || 1;
  const symbol = currentCurrency?.symbol || "₹";

  const user = useSelector((state) => state.myaccount.addMyaccount);

  const [metalId, setMetalId] = useState(null);
  const [sizeId, setSizeId] = useState(null);
  const [tripleId, setTripleId] = useState(null);

  const metals = product?.Product_Variants || [];
  const metal = metals.find((m) => m.id === metalId) || metals[0];
  const sizes = metal?.Double_Variants || [];
  const size = sizes.find((s) => s.id === sizeId) || sizes[0];
  const triples = size?.Triple_Variants || [];
  const triple = triples.find((t) => t.id === tripleId) || triples[0];

  const hasVariants = metals.length > 0;
  const selectedVariant = hasVariants ? triple || size || metal : activeVariant;
  const currentPrice = hasVariants ? selectedVariant?.price || 0 : priceText;
  const currentMrp = hasVariants ? selectedVariant?.mrp || 0 : mrp;
  const currentKgText = hasVariants ? metal?.Metal?.name : kgText;

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const isSignIn = useSelector((state) => state.auth.is_signin);

  const isVendor = user?.role_id && Number(user?.role_id) === RolesIds.Vendor;
  const cartQuantity = isVendor
    ? Number(selectedVariant?.b2b_min_quanity || 1)
    : 1;
  const stock = Number(selectedVariant?.general_stock);
  const isOutOfStock = !(stock > 0);

  const goToDetails = () =>
    navigate(`/product-details/${encodeId(product?.id)}`);

  const addToCart = async () => {
    // validate the selected variant's availability before adding
    if (!selectedVariant?.id || isOutOfStock || cartQuantity > stock) {
      goToDetails();
      return;
    }
    try {
      const data = {
        product_id: product.id,
        variant_type_id: product.variant_type_id,
        quantity: cartQuantity,
      };
      if (Number(product.variant_type_id) === variant_type.Single) {
        data.variant_id = selectedVariant.id;
      } else if (Number(product.variant_type_id) === variant_type.Double) {
        data.d_variant_id = selectedVariant.id;
      } else if (Number(product.variant_type_id) === variant_type.Triple) {
        data.t_variant_id = selectedVariant.id;
      }

      const res = await dispatch(postCart({ data, isSignIn }));
      navigate(`/product-cart`);
      if (res.meta?.requestStatus === "fulfilled") {
        await dispatch(getAllCart(isSignIn));
        window.scrollTo({ top: 0, behavior: "smooth" });
      } else if (res.meta?.requestStatus === "rejected") {
        console.log("Error :", res.payload || "Not In Cart");
      }
    } catch (error) {
      console.log("Error:", error);
    }
  };

  const renderVariantSelect = (options, value, onChange, getLabel) =>
    options.length > 0 && (
      <div className="variant_chips" role="radiogroup">
        {options.map((o) => {
          const soldOut = Number(o.general_stock) <= 0;
          const active = value?.id === o.id;
          return (
            <button
              key={o.id}
              type="button"
              role="radio"
              aria-checked={active}
              disabled={soldOut}
              title={soldOut ? "Out of stock" : undefined}
              className={`variant_chip${active ? " active" : ""}${
                soldOut ? " sold_out" : ""
              }`}
              onClick={() => onChange(o.id)}
            >
              {getLabel(o)}
            </button>
          );
        })}
      </div>
    );

  return (
    <div className="Product_Info_Card_hover_area">
    <div className="Product_Info_Card">
      <Link to={`/product-details/${encodeId(product?.id)}`}>
        <div className="prod_img_holder">
          <img src={imgSrc} className="prod_img" alt={productName} />
          {showdiscount && <div className="offer_tag">{discount_message}</div>}
          <video
            className="prod_video"
            src={vdoSrc}
            muted
            loop
            playsInline
            autoPlay
          />
        </div>
      </Link>

      <div className="best_seller_heart_holder">
        <Best_seller_heart product={product} />
      </div>

      <div className="content_holder">
        <div className="middle_div">
          <p className="categorys-text">{productCategory || ""}</p>
          <Link to={`/product-details/${encodeId(product?.id)}`}>
            <p className="prod_name">
              {productName || ""} {currentKgText || ""}{" "}
            </p>
          </Link>
          <div className="rating-wrapper">
            <StarRatings
              rating={Number(rating) || 0}
              starRatedColor="#FFC107"
              numberOfStars={5}
              name="rating"
              starDimension="18px"
              starSpacing="0px"
            />
            <span>({rating || 0})</span>
          </div>
          {hasVariants && (
            <div className="variant_select_holder">
              {renderVariantSelect(
                metals,
                metal,
                (v) => {
                  setMetalId(v);
                  setSizeId(null);
                  setTripleId(null);
                },
                (o) => o?.Metal?.name,
              )}
              {renderVariantSelect(
                sizes,
                size,
                (v) => {
                  setSizeId(v);
                  setTripleId(null);
                },
                (o) => o?.Size?.name,
              )}
              {renderVariantSelect(
                triples,
                triple,
                setTripleId,
                (o) => o?.Diamond?.name,
              )}
            </div>
          )}
          <div className="price_div">
            {" "}
            {user?.role_id && Number(user?.role_id) === RolesIds.Vendor ? (
              <>
                <p className="s_price_text">
                  {symbol}{" "}
                  {Number(selectedVariant?.b2b_price * rate).toFixed(2)}
                </p>
              </>
            ) : (
              <>
                <p className="s_price_text">
                  {symbol} {Number(currentPrice * rate).toFixed(2)}
                </p>
                <p className="mrp_text">
                  {symbol} {Number(currentMrp * rate).toFixed(2)}
                </p>
              </>
            )}
          </div>
          <div className="btn_holder">
            <section className="Add_to_card_btn">
              <Green_Outline_Btn
                btnText={isOutOfStock ? "Out of stock" : "Shop Now"}
                onClick={isOutOfStock ? goToDetails : addToCart}
              />
            </section>
          </div>
        </div>
      </div>
    </div>
    </div>
  );
};

export default Product_Info_Card;
